import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import OfferCard from '../OfferCard';
import notfound from '../../../../assets/global/not_found.png';
import info from '../../../../assets/global/info.png';
import { clearFilters } from '../../offers.actions';
import {
  isObjectEmpty,
  formatAppliedFilters,
  getAppliedFiltersLabel,
} from '../../../../utils/common.utils';
import ACTION_TYPES from '../../../../store/actionTypes.constants';
import OfferCardLoader from '../OfferCard/loaderCard';
import { useLocation } from 'react-router-dom';
import { ctLogV2 } from '../../../../utils/cleverTapLogger.utils';
import { useIdHash, useNavigateRoute } from '../../../../hooks/custom.hooks';
import { get } from 'lodash';
import { useFilteredData } from '../../../Filters/useFilteredData';

function OffersList({ apiResponse, isLoading, refetch }) {
  const appliedFilters =
    useSelector(({ appReducer }) => appReducer.appliedFilters) || {};
  const dispatch = useDispatch();
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const navigateRoute = useNavigateRoute();
  const { filterOnOfferValue } = useFilteredData();
  // const navigate = useNavigate();
  const { custId: cid, isApp } = useIdHash();

  const offersList = useMemo(() => {
    return get(apiResponse, 'data', []) ?? [];
  }, [apiResponse]);
  const filters = useMemo(() => {
    return get(apiResponse, 'filters', {}) ?? {};
  }, [apiResponse]);

  useEffect(() => {
    if (offersList?.length) {
      dispatch({
        type: ACTION_TYPES.OFFERS_LIST,
        payload: offersList,
      });
    }
  }, [offersList, dispatch]);

  useEffect(() => {
    if (!isObjectEmpty(filters)) {
      dispatch({
        type: ACTION_TYPES.FILTERS,
        payload: filters,
      });
      dispatch({
        type: ACTION_TYPES.CATEGORIES,
        payload: filters.category,
      });
    }
  }, [dispatch, filters]);

  useEffect(() => {
    if (offersList?.length > 10) {
      const copyList = [...offersList];
      setItems(copyList.splice(0, 10));
    }
  }, [offersList]);

  // const { platform = 'all' } = appliedFilters || {};
  // const platformValue = platform || 'all';

  // const memoizedOffersList = useMemo(() => {
  //   return (
  //     offersList?.filter((entry) =>
  //       platformValue !== 'all'
  //         ? (entry.type ?? 'online') === platformValue
  //         : entry,
  //     ) || []
  //   );
  // }, [offersList, platformValue]);

  // // Apply Main Filter
  // const filteredOnCategory = useMemo(() => {
  //   const categoryApplied = appliedFilters?.category ?? [];
  //   const filteredMain = memoizedOffersList.filter((entry) =>
  //     categoryApplied?.includes(entry.category_id),
  //   );
  //   const filteredObjects = memoizedOffersList.filter((item) =>
  //     item.applicable_brand_logos.category_ids?.some((categoryId) =>
  //       categoryApplied?.includes(categoryId),
  //     ),
  //   );
  //   const filteredGlobal = memoizedOffersList.filter(
  //     (entry) => categoryApplied?.length && entry.category_id === 49, //GLOBAL CATEGORY ID
  //   );
  //   let filtered = [...filteredMain, ...filteredObjects, ...filteredGlobal];
  //   filtered = Array.from(
  //     new Set(filtered.map((obj) => JSON.stringify(obj))),
  //   ).map((str) => JSON.parse(str));
  //   // Return all if not filters Selected
  //   const fallback = appliedFilters?.category?.length ? [] : memoizedOffersList;
  //   return filtered.length ? filtered : fallback;
  // }, [appliedFilters.category, memoizedOffersList]);

  // // Apply Sub Filter
  // const filterOnSubCategory = useMemo(() => {
  //   const filteredMain = filteredOnCategory.filter((entry) => {
  //     return appliedFilters?.brand?.includes(entry.brand_id);
  //   });
  //   const filteredObjects = memoizedOffersList.filter((item) =>
  //     item.applicable_brand_logos.brand_ids?.some((brandIds) => {
  //       return appliedFilters.brand?.includes(Number(brandIds));
  //     }),
  //   );
  //   const filteredGlobal = filteredOnCategory.filter(
  //     (entry) => appliedFilters?.brand?.length && entry.brand_id === 1,
  //   );
  //   let filtered = [...filteredMain, ...filteredObjects, ...filteredGlobal];
  //   filtered = Array.from(
  //     new Set(filtered.map((obj) => JSON.stringify(obj))),
  //   ).map((str) => JSON.parse(str));

  //   // Return filtered on Category
  //   return filtered?.length
  //     ? filtered
  //     : appliedFilters.brand?.length
  //       ? []
  //       : filteredOnCategory;
  // }, [appliedFilters.brand, filteredOnCategory, memoizedOffersList]);

  // const filterOnOfferFilterType = useMemo(() => {
  //   const filtered = filterOnSubCategory.filter((entry) =>
  //     appliedFilters?.offer_filter_type?.includes(entry.offer_filter_type),
  //   );
  //   // Return filtered on Category
  //   return filtered?.length
  //     ? filtered
  //     : appliedFilters.offer_filter_type?.length
  //       ? []
  //       : filterOnSubCategory;
  // }, [appliedFilters.offer_filter_type, filterOnSubCategory]);

  // // Apply offer_tag
  // const filterOnOfferTag = useMemo(() => {
  //   const filtered = filterOnOfferFilterType.filter((entry) =>
  //     appliedFilters?.offer_type?.includes(entry.offer_tag),
  //   );
  //   // Return filtered on Category
  //   return filtered?.length
  //     ? filtered
  //     : appliedFilters.offer_type?.length
  //       ? []
  //       : filterOnOfferFilterType;
  // }, [appliedFilters.offer_type, filterOnOfferFilterType]);

  // // Apply reward_offer
  // const filterOnIssuer = useMemo(() => {
  //   const filtered = filterOnOfferTag.filter((entry) =>
  //     appliedFilters?.reward_offer?.includes(entry.brand_id),
  //   );
  //   // Return filtered on Category
  //   return filtered?.length
  //     ? filtered
  //     : appliedFilters.reward_offer?.length
  //       ? []
  //       : filterOnOfferTag;
  // }, [appliedFilters.reward_offer, filterOnOfferTag]);

  // // Apply offer_value
  // const filterOnOfferValue = useMemo(() => {
  //   const offerValue = Number(
  //     appliedFilters?.offer_value?.length ? appliedFilters?.offer_value[0] : 0,
  //   );
  //   const filtered = filterOnIssuer.filter((entry) => {
  //     return offerValue === 0 ? entry : offerValue <= entry.offer_value;
  //   });
  //   // Return filtered on Category
  //   return filtered?.length
  //     ? filtered
  //     : appliedFilters.offer_value?.length
  //       ? []
  //       : filterOnIssuer;
  // }, [appliedFilters.offer_value, filterOnIssuer]);

  const handleScroll = useCallback(() => {
    const container = document.getElementById('offersScroll');
    if (!container) return;

    // Check if we've scrolled to the bottom
    const isBottom =
      container.scrollHeight === container.scrollTop + container.clientHeight;
    if (isBottom) {
      const originalList = [...offersList];
      setPage((prevPage) => prevPage + 1);
      const start = page * 10;
      const end = start + 10;
      const initialItems = originalList.slice(start, end);
      setItems([...items, ...initialItems]);
    }
  }, [items, offersList, page]);

  // Add scroll event listener
  useEffect(() => {
    const container = document.getElementById('offersScroll');
    if (container && offersList.length > 10) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll, offersList.length]);

  // Clevertap Parsing
  const fullUrl = window.location.href;
  const formattedAppliedFilters =
    formatAppliedFilters(appliedFilters, filters) || '';
  const voucherCampaignDetailsIds = filterOnOfferValue
    .slice(0, 10)
    .map((filter) => filter.voucher_campaign_details_id)
    .join(', ');
  const claimCtaOffersCount = filterOnOfferValue.filter((filter) =>
    ['recommended', 'exclusive'].includes(filter.offer_filter_type),
  ).length;
  const visitStoreCtaOffersCount =
    filterOnOfferValue.length - claimCtaOffersCount;

  const filterTypeText = localStorage.getItem('filterTypeText');
  // @TODO : `activeSource` To be updated dynamically
  const activeSource =
    filterTypeText !== ''
      ? 'filter_applied'
      : isApp
        ? 'applp_viewalloffers'
        : 'weblp_v1_viewalloffers';
  if (filterTypeText === 'quick_filter') {
    ctLogV2({
      eventName: 'Web_Filter_applied',
      eventCategory: 'Offer Listing Page',
      eventDescription: 'Offer Listing Page - Web Filter Applied',
      customerId: cid,
      extraData: {
        Filter_selected: formatAppliedFilters(appliedFilters, filters) || '',
        filter_type: filterTypeText,
        filter_labels: getAppliedFiltersLabel(appliedFilters) || '',
      },
    });
  }

  // ScrollToItem
  useEffect(() => {
    if (!isLoading && offersList.length && location.state?.navigated) {
      document.getElementById('offersScroll').scrollTop =
        localStorage.getItem('offerListST');
    }
    ctLogV2({
      eventName: 'Web_Offerlistingpage_viewed',
      eventCategory: 'Offer Listing Page',
      eventDescription: 'Offer Listing Page - Viewed',
      customerId: cid || '',
      extraData: {
        identity: cid || '',
        url: fullUrl ?? '',
        platform: isApp ? 'app' : 'web',
        source: activeSource || '',
        offers_count: filterOnOfferValue.length,
        filters_pre_applied: formattedAppliedFilters || '',
        offers_list: voucherCampaignDetailsIds || '',
        claimcta_offerscount: claimCtaOffersCount || 0,
        visitstorecta_offerscount: visitStoreCtaOffersCount || 0,
      },
    });
  }, [
    isLoading,
    location,
    offersList.length,
    fullUrl,
    activeSource,
    filterOnOfferValue.length,
    formattedAppliedFilters,
    voucherCampaignDetailsIds,
    claimCtaOffersCount,
    visitStoreCtaOffersCount,
    cid,
    isApp,
  ]);

  if (isLoading) {
    return (
      <div className={styles.offersListWrapper}>
        {[...Array(9)].map((_, index) => (
          <OfferCardLoader key={index} />
        ))}
      </div>
    );
  }

  let clearOption = false;
  if (!isObjectEmpty(appliedFilters)) {
    clearOption = Boolean(
      appliedFilters?.category?.length ||
        appliedFilters?.brand?.length ||
        appliedFilters?.reward_offer?.length ||
        // appliedFilters?.offer_value?.length || //to hide remove filter
        appliedFilters?.offer_type?.length,
    );
  }

  return (
    <div
      className={styles.offersListWrapper}
      id="offersScroll"
      style={{
        height: filterOnOfferValue.length > 10 ? '100dvh' : '100%',
      }}
    >
      {filterOnOfferValue.length ? (
        <div>
          {filterOnOfferValue.length < offersList.length || clearOption ? (
            <div className={styles.showingFiltered}>
              <div className={styles.left}>
                Showing {filterOnOfferValue.length} results
              </div>
              <div
                className={styles.clear}
                onClick={() => {
                  // navigate(`/?cid=${cid}&customer-hash=${hash}&app=${isApp}`);
                  dispatch(clearFilters());
                  navigateRoute({
                    nextPage: '/offers',
                  });
                  localStorage.setItem('filterTypeText', '');
                }}
              >
                CLEAR FILTER
              </div>
            </div>
          ) : null}
          {filterOnOfferValue.map((entry, index) => {
            return (
              <OfferCard
                offer={entry}
                key={index}
                keyIndex={index}
                data={apiResponse}
              />
            );
          })}
        </div>
      ) : (
        <div className={styles.notFound}>
          <img src={notfound} alt="noResults" className={styles.notFoundImg} />
          <div className={styles.textRow}>
            <img src={info} alt="info" />
            <div>No Results Found</div>
          </div>
          <div
            className={styles.clearFilters}
            onClick={() => {
              if (offersList.length) {
                dispatch(clearFilters());
                navigateRoute({
                  nextPage: '/offers',
                });
              } else {
                refetch();
              }
            }}
          >
            {offersList.length ? 'Clear all filters' : 'Retry'}
          </div>
        </div>
      )}
    </div>
  );
}

export default OffersList;
